import React from 'react'

import Actions from './actions/Actions'
import OverflowText from './overflowText/OverflowText'

type Props = {
  id: string
  name: string
  description?: string
  categoryPath: string[]
  onClickEditName?: () => void
  onClickDeleteProduct?: () => void
}

const ProductCard = ({
  id,
  name,
  description,
  categoryPath,
  onClickEditName,
  onClickDeleteProduct,
}: Props) => {
  return (
    <div className="w-full flex flex-col gap-4 bg-gold-50 bg-opacity-60 p-4">
      <div className="flex justify-between">
        <div className="text-xxs font-medium text-gold-700 flex flex-col gap-1">
          <div aria-label={`ID: ${id}`}>ID: {id}</div>
          <div className="self-stretch min-w-50 flex gap-4">
            {categoryPath.length > 0 && (
              <div
                className="inline-flex items-center gap-0.5 text-gold-700 text-xxs flex-wrap"
                aria-label="Category path"
              >
                {categoryPath.map((pathItem, i) => (
                  <React.Fragment key={pathItem}>
                    <div className="break-words">{pathItem}</div>
                    {i < categoryPath.length - 1 && (
                      <span aria-hidden="true">/</span>
                    )}
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
        </div>
        <Actions
          name={name}
          onClickEditName={onClickEditName}
          onClickDeleteProduct={onClickDeleteProduct}
        />
      </div>
      <div className="flex flex-col gap-1 text-base-700">
        <h4 className="text-xs">{name}</h4>
        <OverflowText text={description || 'No description available'} />
      </div>
    </div>
  )
}

export default ProductCard
